import './card-history.scss';

export default () => {
};
